var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-avatar',{staticClass:"profile-avatar ma-0",attrs:{"size":_vm.size}},[(_vm.profilePicture)?_c('v-img',{attrs:{"src":_vm.profilePicture}}):_c('v-icon',{attrs:{"size":_vm.size * 1.2,"color":"secondary"}},[_vm._v(" mdi-account-circle ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }